import { z } from "zod";
import type { PaginatedData } from "@core/types/TApiResponse";
import { ProjectRoleSchema } from "@modules/project/_shared/types";

export type { TProjectRole } from "@modules/project/_shared/types";

export type TMemberProjectStatus = "active" | "archived";

export const MemberProjectSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  code: z.string().nullable(),
  client: z.string().nullable(),
  owner: z.string().nullable(),
  start_date: z.string().nullable(),
  end_date: z.string().nullable(),
  is_active: z.boolean(),
  role: ProjectRoleSchema,
  is_client_owner: z.boolean(),
  created_at: z.string(),
});

export type TMemberProject = z.infer<typeof MemberProjectSchema>;

export type TMemberProjectQueryParams = {
  page?: number;
  size?: number;
  search?: string;
  sort_by?: string;
  sort_order?: "asc" | "desc";
  is_active?: boolean;
};

export type TMemberProjectListData = PaginatedData<TMemberProject>;
